"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPersonal = void 0;
var Yup = __importStar(require("yup"));
var i18n_1 = __importDefault(require("../../i18n"));
var GeneralSettings_1 = require("../../constants/GeneralSettings");
var PropertyTypes_1 = require("../../types/SearchPage/PropertyTypes");
var lodash_1 = require("lodash");
// Land has no rooms, interior or building: those fields are hidden in the form.
var NOT_FOR_LAND = [PropertyTypes_1.PROPERTY_TYPE.LAND];
var requiredPersonal = {
    initial_info: {
        property_type: true,
        structure_type: true,
    },
    property_info: {
        address_picker: {
            addressData: {
                address: true,
                district: true,
                state: true,
            },
            districtId: true,
            location: {
                lat: true,
                lng: true,
            },
            stateId: true,
        },
    },
    apartment_info: {
        floor: true,
        rooms: true,
        area: true,
        currency: true,
        bedrooms: true,
        renovation: true,
        cooling: true,
        heating: true,
        // required only when the property type is land
        land_purpose: {
            path: 'initial_info.property_type',
            value: PropertyTypes_1.PROPERTY_TYPE.LAND,
        },
    },
    about_building: {
        building_floors: true,
    },
};
var getPersonal = function () {
    return {
        initial_info: Yup.object().shape({
            property_type: Yup.string().requiredIf(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), requiredPersonal, 'initial_info.property_type'),
            structure_type: Yup.string().requiredIf(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), requiredPersonal, 'initial_info.structure_type'),
        }),
        property_info: Yup.object().shape({
            address_picker: Yup.object().addressPicker(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD')),
        }),
        apartment_info: Yup.array().of(Yup.object().shape({
            floor: Yup.string()
                .nullable()
                .requiredByPropertyType(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), [GeneralSettings_1.PROPERTY_TYPES.COMMERCIAL, GeneralSettings_1.PROPERTY_TYPES.APARTMENT]),
            rooms: Yup.string()
                .nullable()
                .requiredUnlessPropertyType(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), NOT_FOR_LAND),
            area: Yup.number()
                .positive()
                .typeError(i18n_1.default.t('common:ERROR_MESSAGES.NUMERIC_FIELD'))
                .requiredIf(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), requiredPersonal, 'apartment_info.area'),
            price: Yup.number()
                .positive()
                .typeError(i18n_1.default.t('common:ERROR_MESSAGES.NUMERIC_FIELD'))
                .when(['price_is_checked', 'daily_price_is_checked'], {
                is: function (price_is_checked, daily_price_is_checked) {
                    if ((!lodash_1.isUndefined(price_is_checked) &&
                        Boolean(Number(price_is_checked))) ||
                        (!lodash_1.isUndefined(daily_price_is_checked) &&
                            !Boolean(Number(daily_price_is_checked)))) {
                        return true;
                    }
                    else if (lodash_1.isUndefined(price_is_checked) &&
                        !Boolean(Number(price_is_checked)) &&
                        lodash_1.isUndefined(daily_price_is_checked) &&
                        !Boolean(Number(daily_price_is_checked))) {
                        return true;
                    }
                },
                then: Yup.number().required(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD')),
            }),
            daily_price: Yup.number()
                .positive()
                .typeError(i18n_1.default.t('common:ERROR_MESSAGES.NUMERIC_FIELD'))
                .when(['daily_price_is_checked', 'price_is_checked'], {
                is: function (daily_price_is_checked, price_is_checked) {
                    if ((!lodash_1.isUndefined(daily_price_is_checked) &&
                        Boolean(Number(daily_price_is_checked))) ||
                        (!lodash_1.isUndefined(price_is_checked) &&
                            !Boolean(Number(price_is_checked)))) {
                        return true;
                    }
                },
                then: Yup.number().required(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD')),
            }),
            currency: Yup.string().requiredIf(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), requiredPersonal, 'apartment_info.currency'),
            bedrooms: Yup.string()
                .nullable()
                .requiredByPropertyType(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), [GeneralSettings_1.PROPERTY_TYPES.HOUSE, GeneralSettings_1.PROPERTY_TYPES.APARTMENT]),
            renovation: Yup.string()
                .nullable()
                .requiredUnlessPropertyType(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), NOT_FOR_LAND),
            cooling: Yup.string()
                .nullable()
                .requiredUnlessPropertyType(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), NOT_FOR_LAND),
            heating: Yup.array()
                .nullable()
                .ensure()
                .requiredUnlessPropertyType(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), NOT_FOR_LAND),
            land_purpose: Yup.string()
                .nullable()
                .requiredIf(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), requiredPersonal, 'apartment_info.land_purpose'),
        })),
        about_building: Yup.object().shape({
            building_floors: Yup.number()
                .positive()
                .typeError(i18n_1.default.t('common:ERROR_MESSAGES.NUMERIC_FIELD'))
                .requiredUnlessPropertyType(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRED_FIELD'), NOT_FOR_LAND),
        }),
        contact: Yup.object({
            contacts: Yup.array()
                .of(Yup.object().shape({
                phone: Yup.string().armPhone(i18n_1.default.t('common:ERROR_MESSAGES.INVALID_ARM_PHONE')),
            }))
                .unique(i18n_1.default.t('common:ERROR_MESSAGES.DUPLICATE_PHONE'), 'contact.contacts', 'phone')
                .requiredAtLeastOnePhoneNumber(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRE_AT_LEAST_ONE_PHONE_NUMBER')),
        }),
        acceptTerms: Yup.bool().oneOf([true], i18n_1.default.t('common:ERROR_MESSAGES.READ_OUR_CONDITIONS')),
    };
};
exports.getPersonal = getPersonal;
